<template>
  <v-menu v-model="mostrar" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon> mdi-dots-vertical </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
      v-if="mixValidaScopesActions(2)"
      @click="editar" link>
        <v-list-item-icon>
          <v-icon> mdi-pencil </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Editar </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
      v-if="mixValidaScopesActions(3)"
      @click="borrar" link>
        <v-list-item-icon>
          <v-icon> mdi-delete </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Eliminar </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesAdjudicaciones',
  props: {
    adjudicacionDirecta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-adjudicacionDirecta', this.adjudicacionDirecta);
    },
    borrar() {
      eventBus.$emit('eliminar-adjudicacionDirecta', this.adjudicacionDirecta);
    },
  },
};
</script>

<style lang="scss">
</style>
